// global process
import { init, BrowserTracing } from "@sentry/react";

export const initiateSentry = dsn => {
    const TRANSACTIONS_RATIO = 0.1;
    const isProduction = process.env.NODE_ENV === "production";

    init({
        dsn,
        environment: process.env.NODE_ENV,
        integrations: isProduction ? [new BrowserTracing()] : [],
        tracesSampler: samplingContext => {
            if (!isProduction || samplingContext?.location?.origin?.includes?.("ppe")) {
                return 0;
            }

            return TRANSACTIONS_RATIO;
        },
        beforeSend(event) {
            if (isFilteredOut(event)) {
                return null;
            }

            return event;
        }
    });
};

export const stripUrls = data => {
    const frames = data?.exception?.values?.[0]?.stacktrace?.frames;
    if (frames) {
        frames.forEach(frame => (frame.filename = cleanse(frame.filename)));
    }
    data.transaction = cleanse(data.transaction);
    return data;
};

const cleanse = filename => {
    const fileSplit = filename.split("/");
    return "~/" + fileSplit[fileSplit.length - 1];
};

export const isFilteredOut = event =>
    !!event?.exception?.values?.some?.(
        entry => entry.type === "HTTPError" && isIgnored(entry.value)
    );

const isIgnored = message => {
    const errorRegexList = [
        /^HTTP GET request.*\/nucleus-nuclear\/nui\/nbs\/accounts\/.*modelPortfolio.*status code 404\.$/
    ];

    return !!(message?.match && errorRegexList.map(regex => !!message.match(regex)).includes(true));
};
